import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/phone'));

export default function (dependencies) {
  const { language, validators } = dependencies;

  var config = {
    label: language['phone-label'],
    autoComplete: 'tel-national',
    placeholder: language['phone-placeholder'],
    foreignPlaceholderPrefix: language['phone-foreign-placeholder-prefix'],
    format: 'integer',
    allowForeign: true,
    extraState: { foreign: false },
    maxLength: 8,
    validatorsNormal: ['mandatory', 'numberOfDigits:8'],
    behaviour: 'text-input',
  };

  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    config: config,
    validators: [validatePhone(validators)],
  };

  function validatePhone({ mandatory, minLength, maxLength, matches, get }) {
    return function phone(state, config) {
      if (state.foreign)
        return [
          mandatory(),
          matches(/^\+/, language['phone-must-begin-with-+']),
          matches(/^\s*(\+|00)?[-\.\d\(\) ]{1,}\s*$/, language['phone-invalid']),
        ];
      else {
        return [...(config.validatorsNormal || []).map((key) => get(key)()), invalidPhoneNumber(/^(\d)\1{7,}$/)];
      }
    };

    function invalidPhoneNumber(number) {
      return matches(number, language['phone-invalid'], true);
    }
  }
}
